module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-billing-list/bc-allowance-modal/bc-allowance-modal.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-billing-list/bc-allowance-modal/bc-allowance-modal.component.scss
// module chunks = main